import * as React from 'react';
import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';

import {
  columns,
  horizontalGutterSize,
  leftColspan,
  rightColspan,
  verticalGutterSize,
} from './Common';

export const LayoutWideLeft: React.FunctionComponent = props => <div {...props} />;

export const ColumnWide = Styled.aside`
  margin-bottom: ${horizontalGutterSize};
  overflow: auto;
  width: 100%;

  ${media.medium`
    flex: 0 0 calc( ${(leftColspan / columns) * 100}% - (${verticalGutterSize} / 2));
  `}
`;

export const ConditionalColumnWide = Styled(ColumnWide)`
  display: none;

  ${media.medium`
    display: flex;
  `}
`;

export const ColumnShort = Styled.aside`
  flex: 0 0 100%;
  margin-bottom: ${horizontalGutterSize};

  ${media.medium`
    flex: 0 0 calc( ${(rightColspan / columns) * 100}% - (${verticalGutterSize} / 2));
    &:last-child {
      margin-left: ${verticalGutterSize};
    }
  `}
`;

ColumnShort.displayName = 'ColumnShort';
ColumnWide.displayName = 'ColumnWide';
ConditionalColumnWide.displayName = 'ConditionalColumnWide';
